import axios from '@/axios.js'

let entityURL = 'productCategories'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = {'Authorization': `bearer ${token}`}

const state = {
    settingCategories: [],
    settingBrands: [],
    settingGroups: [],
    settingCategory: {},
    displayCategoryPopUp: false,
    categoryPopUpTitle: 'Νέα Εγγραφή'
}

const getters = {
    getSettingCategories: (state) => (state.settingCategories),
    getSettingGroups: (state) => (state.settingGroups),
    getSettingBrands: (state) => (state.settingBrands),
    getSettingCategory: (state) => (state.settingCategory),
    getDisplayCategoryPopUp: (state) => (state.displayCategoryPopUp),
    getCategoryPopUpTitle: (state) => (state.categoryPopUpTitle),
}

const actions = {
    // Add new category
    async addSettingCategory({commit}, payload) {
        const response = await axios.post(`${entityURL}/add`, payload)
        commit('ADD_SETTING_CATEGORY', response.data.object)
    },

    // Fetch Categories
    async fetchSettingCategories({commit}) {
        const response = await axios(`${entityURL}/list`)
        commit('SET_SETTING_CATEGORIES', response.data)
    },

    // Fetch Brands
    async fetchSettingBrands({commit}) {
        const response = await axios(`${entityURL}/brand_list`)
        commit('SET_SETTING_BRANDS', response.data)
    },

    // Fetch Groups
    async fetchSettingGroups({commit}) {
        const response = await axios(`${entityURL}/group_list`)
        commit('SET_SETTING_GROUPS', response.data)
    },

    // Fetch Category
    async fetchSettingCategory({commit}, payloadId) {
        const response = await axios(`${entityURL}/get/${payloadId}`)
        commit('SET_SETTING_CATEGORY', response.data)
    },

    // Update Category
    async updateSettingCategory({commit}, payload) {
        const response = await axios.put(`${entityURL}/update/${payload.id}`, payload)
        commit('UPDATE_SETTING_CATEGORY', response.data.object)
    },

    // Delete Category
    async deleteSettingCategory({commit}, payloadId) {
        const response = await axios.delete(`${entityURL}/delete/${payloadId}`)
        if (response.data.message === 'Successfully Deleted') {
            commit('DELETE_SETTING_CATEGORY', payloadId)
        }
    },

    // Set category pop up status
    setCategoryPopUpStatus({commit}, value) {
        commit('SET_CATEGORY_POP_UP_STATUS', value)
    },

    // Set category pop up title
    setCategoryPopUpTitle({commit}, value) {
        commit('SET_CATEGORY_POP_UP_TITLE', value)
    },

    // Set Category item
    setSettingCategoryItem({commit}, payload) {
        commit('SET_SETTING_CATEGORY_ITEM', payload)
    },

    // Setter functions for name, order and color
    setSettingCategoryName({commit}, value) {
        commit('SET_SETTING_CATEGORY_NAME', value)
    },
    setSettingCategoryOrder({commit}, value) {
        commit('SET_SETTING_CATEGORY_ORDER', value)
    },
    setSettingCategoryColor({commit}, value) {
        commit('SET_SETTING_CATEGORY_COLOR', value)
    },
}

const mutations = {
    // Add new category
    ADD_SETTING_CATEGORY: (state, data) => (state.settingCategories.push(data)),
    SET_SETTING_CATEGORIES: (state, data) => (state.settingCategories = data),
    SET_SETTING_BRANDS: (state, data) => (state.settingBrands = data.object),
    SET_SETTING_GROUPS: (state, data) => (state.settingGroups = data.object),
    SET_SETTING_CATEGORY: (state, data) => (state.settingCategory = data),
    UPDATE_SETTING_CATEGORY: (state, data) => {
        let categoryIndex = state.settingCategories.findIndex(x => x.id === data.id)
        if (categoryIndex !== -1) {
            state.settingCategories.splice(categoryIndex, 1, data)
            state.settingCategory = data
        }
    },
    DELETE_SETTING_CATEGORY: (state, data) => {
        let categoryIndex = state.settingCategories.findIndex(x => x.id === data)
        if (categoryIndex !== -1) {
            state.settingCategories.splice(categoryIndex, 1)
        }
    },
    SET_CATEGORY_POP_UP_STATUS: (state, data) => (state.displayCategoryPopUp = data),
    SET_CATEGORY_POP_UP_TITLE: (state, data) => (state.categoryPopUpTitle = data),
    SET_SETTING_CATEGORY_ITEM: (state, data) => (state.settingCategory = data),
    SET_SETTING_CATEGORY_NAME: (state, value) => (state.settingCategory.name = value),
    SET_SETTING_CATEGORY_ORDER: (state, value) => (state.settingCategory.order = value),
    SET_SETTING_CATEGORY_COLOR: (state, value) => (state.settingCategory.color = value),
}

export default {state, getters, actions, mutations}
